import React from 'react'

interface SidebarDrawerProps {
    isOpen: boolean
    onClose: () => void
    children?: React.ReactNode
    title: string
}

export const SidebarDrawer: React.FC<SidebarDrawerProps> = ({
    isOpen,
    onClose,
    children,
    title,
}) => {
    return (
        <>
            {/* Overlay */}
            <div
                className={`fixed inset-0 bg-slate-900/15 transition-opacity ${
                    isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
                }`}
                onClick={onClose}
            />

            {/* Sidebar Drawer */}
            <div
                className={`fixed top-0 right-0 h-full w-[50%] bg-white shadow-lg z-50 transform transition-transform duration-300 ${
                    isOpen ? 'translate-x-0' : 'translate-x-full'
                }`}
            >
                <div className="flex flex-col h-full">
                    {/* Header */}
                    <div className="p-4 flex justify-between items-center border-b shrink-0">
                        <h2 className="text-lg font-semibold">{title}</h2>
                        <button onClick={onClose} className="text-gray-500 hover:text-black">
                            ✕
                        </button>
                    </div>

                    {/* Content */}
                    <div className="flex-1 overflow-auto">{children}</div>
                </div>
            </div>
        </>
    )
}
